import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Text } from '@chakra-ui/react';

import CertificateCreationBlueprintType from '../../../types/CertificateCreationBlueprintType';
import CreepingProgressBar from '../../CreepingProgressBar';

const SubmissionProgress = ({ blueprint }) => {
  const loadingHeaderText = useSelector(blueprint.selectLoadingHeaderText);
  const loadingSubText = useSelector(blueprint.selectLoadingSubText);
  const willScanDocuments = useSelector(blueprint.selectWillScanDocuments);

  return (
    <Box flexFlow="row nowrap" justifyContent="center" mt={8} textAlign="center" w="100%">
      <Text color="greyScale.700" mb={4} textStyle="displayXs600">{loadingHeaderText}</Text>
      <Text color="greyScale.700" textStyle="bodyLg500">{loadingSubText}</Text>

      <Box maxW="480px" mt={8} mx="auto">
        <CreepingProgressBar
          label={willScanDocuments ? 'Scanning documents for expiration dates...' : 'Submitting...'}
        />
      </Box>
    </Box>
  );
};

SubmissionProgress.propTypes = { blueprint: CertificateCreationBlueprintType.isRequired };

export default SubmissionProgress;
